import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

gsap.registerPlugin(ScrollTrigger);

function dm_vac_01_animated_intro_text() {
	const sections = document.querySelectorAll(".vac-01-animated-intro-text");

	sections.forEach((section) => {
		const media = gsap.matchMedia();

		media.add(
			{
				desktop: "(min-width: 992px)",
				mobile: "(max-width: 991.98px)",
			},
			(context) => {
				const contentSelector = context.conditions.desktop
					? ".content"
					: ".content-mobile";
				const content = section.querySelector(contentSelector);
				const slots = gsap.utils.toArray(
					content?.querySelectorAll(".vac-inline-image-slot") || []
				);
				const images = gsap.utils.toArray(
					content?.querySelectorAll(
						".vac-inline-image-slot .vac-inline-image"
					) || []
				);

				if (!slots.length || !images.length) return;

				let targetWidth = 0;

				const syncImageWidths = () => {
					gsap.set(images, { clearProps: "width" });
					targetWidth = images[0].getBoundingClientRect().width;
					gsap.set(images, { width: targetWidth });
				};

				syncImageWidths();
				gsap.set(slots, { width: 0 });

				const tl = gsap.timeline({
					scrollTrigger: {
						trigger: section,
						start: "top 90%",
						end: "bottom 90%",
						scrub: true,
						markers: false,
						invalidateOnRefresh: true,
						onRefreshInit: syncImageWidths,
					},
				});

				const imageOffset = 0.12;
				const animationEnd = 0.9;

				slots.forEach((slot, index) => {
					const start = index * imageOffset;
					const duration = animationEnd - start;

					tl.to(
						slot,
						{
							width: () => targetWidth,
							duration,
							ease: "none",
						},
						start
					);
				});

				// Keep both images fully revealed for the final 10% of the scroll range.
				tl.to({}, { duration: 1 - animationEnd }, animationEnd);
			}
		);
	});
}

export { dm_vac_01_animated_intro_text };
